module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatRoomBox",
    class: {
      'newMessage': _vm.newMessage
    }
  }, [(!_vm.showRoom) ? _c('span', {
    staticClass: "door",
    on: {
      "click": function($event) {
        _vm.showRoom = true;
        _vm.IsAddRoom = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/chatRoom_show.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.IsAddRoom) ? _c('div', {
    staticClass: "chatRoom",
    class: {
      'closeRoom': !_vm.showRoom
    },
    on: {
      "mouseenter": function($event) {
        return _vm.mouseenter()
      },
      "mouseleave": function($event) {
        return _vm.mouseout()
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("消息推送"), _c('span', {
    staticClass: "btn_title"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.data = [];
        _vm.clearNotice()
      }
    }
  }, [_vm._v("清空")]), _c('span', {
    on: {
      "click": function($event) {
        _vm.showRoom = false;
        _vm.newMessage = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "chatRoomScroll"
    }
  }, [_c('ul', _vm._l((_vm.data), function(v, i) {
    return _c('li', {
      key: i,
      class: {
        'right': v.type === 1, 'systemMessage': v.type === 3
      }
    }, [_c('div', {
      staticClass: "box"
    }, [(v.type !== 3) ? _c('div', {
      staticClass: "headerImg"
    }, [_c('img', {
      attrs: {
        "src": v.type === 1 ? './static/chatRoom/other.png' : './static/chatRoom/mine.png',
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (v.type !== 3) ? _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', [_vm._v(_vm._s(v.name))])]), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(v.text) + "\n                "), _c('span', {
      class: v.type === 1 ? 'triangle2' : 'triangle1'
    })])]) : _c('div', {
      staticClass: "systemItem",
      class: {
        'withdraw': v.messageType === 1, 'recharge': v.messageType == 0, 'systemType': v.messageType == 3
      }
    }, [_c('div', {
      staticClass: "systemTitle"
    }, [_vm._v(_vm._s(v.messageType === 0 ? '充值消息: ' : v.messageType === 1 ? '提现消息:' : v.messageType === 2 ? '派奖消息:' : v.messageType === 3 ? '系统消息' : '') + _vm._s(v.title)), _c('br'), _vm._v(_vm._s(v.time) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "systemContent",
      domProps: {
        "innerHTML": _vm._s(v.text)
      }
    })])])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-56447272"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/chatRoom_pc.vue
// module id = 888
// module chunks = 9